import { render, staticRenderFns } from "./RewardTypeLabel.vue?vue&type=template&id=ea5bd4a2&"
import script from "./RewardTypeLabel.vue?vue&type=script&lang=js&"
export * from "./RewardTypeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports